// GENERATED BY process-svg DO NOT EDIT
import React from 'react'

import { GeneratedIcon } from './Icon'
import { GeneratedIconProps } from './Icon/types'

export const IconHome = (props: GeneratedIconProps) => (
  <GeneratedIcon {...props}>
    <use xlinkHref="#icon-home" />
  </GeneratedIcon>
)

IconHome.displayName = 'IconHome'
